/* Welcome offer popup. Official Shopify Forms captures signups when enabled; the native
   customer form remains the fallback. Discount codes come from existing theme settings. */
(function () {
  'use strict';

  var dialog = document.querySelector('[data-promo]');
  var tab = document.querySelector('[data-promo-tab]');
  if (!dialog || !tab) return;

  var STORAGE = 'fore2feet.fit2you.page.v1';
  var data = JSON.parse(dialog.querySelector('[data-promo-data]').textContent);
  var host = dialog.querySelector('[data-promo-step-host]');
  var errorNode = dialog.querySelector('[data-promo-error]');
  var vehicle = dialog.querySelector('form[action*="/contact"]');
  var formsEnabled = dialog.getAttribute('data-shopify-forms') === 'true';
  var formsReservoir = dialog.querySelector('[data-promo-forms-reservoir]');
  var formSlots = {};
  if (formsEnabled) dialog.querySelectorAll('[data-promo-forms-slot]').forEach(function (slot) { formSlots[slot.getAttribute('data-promo-forms-slot')] = slot; });
  var activityHtml = host.innerHTML;
  var templates = {};
  dialog.querySelectorAll('template[data-promo-step]').forEach(function (t) { templates[t.getAttribute('data-promo-step')] = t; });

  var step = 'activity';
  var variant = 'sport';
  var activity = '';
  var email = '';
  var offer = { rate: 0, code: '' };
  var priorFocus = null;
  var pending = false;
  var explicitOpened = false;
  var formReadyTimer = null;
  var verificationTimer = null;
  var backdrop = null;
  if (formsEnabled) {
    backdrop = document.createElement('div');
    backdrop.className = 'promo-forms-backdrop';
    backdrop.hidden = true;
    backdrop.setAttribute('aria-hidden', 'true');
    document.body.appendChild(backdrop);
    dialog.setAttribute('aria-modal', 'true');
  }

  /* ---------- saved fit state (shared with the fit funnel; only the offer fields and email are touched) ---------- */
  function readState() {
    try {
      var value = JSON.parse(localStorage.getItem(STORAGE) || 'null');
      return value && typeof value === 'object' ? value : null;
    } catch (e) { return null; }
  }
  function saveOffer(rate, code) {
    var state = readState() || { schemaVersion: 2 };
    state.promoRate = rate;
    state.promoCode = code;
    state.promoMode = 'live';
    if (email.trim()) state.profile = Object.assign({}, state.profile, { email: email.trim() });
    try { localStorage.setItem(STORAGE, JSON.stringify(state)); } catch (e) { /* Storage can be unavailable; the offer still shows. */ }
  }
  function loadOffer() {
    var state = readState();
    if (state && (state.promoRate === 15 || state.promoRate === 20) && /^[A-Za-z0-9_-]{1,50}$/.test(state.promoCode || '') && state.promoMode) {
      offer = { rate: state.promoRate, code: state.promoCode };
    }
  }
  function fitStarted() {
    var state = readState();
    return Boolean(state && (state.completed || state.inCart));
  }

  function remember(key, value) { try { sessionStorage.setItem(key, value); } catch (e) { /* Private mode: the offer may reappear. */ } }
  function recall(key) { try { return sessionStorage.getItem(key); } catch (e) { return null; } }

  /* ---------- rendering ---------- */
  function updateTab() { tab.textContent = offer.rate ? offer.rate + '% offer' : 'Save up to 20%'; }

  function showError(message) {
    errorNode.textContent = message || '';
    errorNode.hidden = !message;
  }

  function setPending(value) {
    pending = value;
    host.querySelectorAll('.promo-primary, .promo-skip').forEach(function (button) { button.disabled = value; });
    var primary = host.querySelector('button.promo-primary');
    if (primary) {
      if (value) { primary.setAttribute('data-label', primary.textContent); primary.textContent = 'Saving…'; }
      else if (primary.getAttribute('data-label')) primary.textContent = primary.getAttribute('data-label');
    }
  }

  function renderActivity() {
    host.innerHTML = activityHtml;
    var set = data[variant];
    host.querySelector('[data-promo-question]').textContent = set.question;
    var choices = host.querySelector('[data-promo-choices]');
    choices.textContent = '';
    set.choices.forEach(function (label) {
      var button = document.createElement('button');
      button.type = 'button';
      button.textContent = label;
      choices.appendChild(button);
    });
  }

  function show(name, focus) {
    clearTimeout(formReadyTimer);
    step = name;
    showError('');
    pending = false;
    if (formsEnabled) Object.keys(formSlots).forEach(function (key) { formsReservoir.appendChild(formSlots[key]); });
    if (name === 'activity') renderActivity();
    else host.replaceChildren(templates[name].content.cloneNode(true));
    if (formsEnabled && formSlots[name]) {
      var mount = host.querySelector('[data-promo-forms-mount]');
      mount.appendChild(formSlots[name]);
      var status = document.createElement('p');
      status.setAttribute('role', 'status');
      status.textContent = 'Loading secure signup…';
      mount.appendChild(status);
      var checks = 0;
      var waitForForm = function () {
        var embed = formSlots[name].querySelector('shopify-forms-embed');
        if (embed && embed.shadowRoot && embed.shadowRoot.querySelector('form')) { status.remove(); return; }
        if (++checks >= 40) {
          status.textContent = 'Signup is temporarily unavailable. Please refresh the page and try again.';
          return;
        }
        formReadyTimer = setTimeout(waitForForm, 250);
      };
      waitForForm();
      try { sessionStorage.setItem('f2f.offer.forms.pending', JSON.stringify({ channel: name, activity: activity, at: Date.now() })); } catch (e) { /* Completion remains a public welcome code; no personal data is stored here. */ }
    } else if (name === 'email') host.querySelector('#offer-email').value = email;
    if (name === 'success') fillSuccess();
    if (focus) {
      var heading = host.querySelector('#promo-title');
      if (heading) heading.focus({ preventScroll: true });
    }
  }

  function fillSuccess() {
    var rate = offer.rate || 15;
    host.querySelector('[data-promo-rate]').textContent = String(rate);
    host.querySelectorAll('[data-promo-price]').forEach(function (el) { el.hidden = el.getAttribute('data-promo-price') !== String(rate); });
    var upgrade = host.querySelector('[data-promo-upgrade]');
    upgrade.hidden = offer.rate !== 15;
    var copy = host.querySelector('[data-promo-copy]');
    copy.insertBefore(document.createTextNode(offer.code + ' '), copy.firstChild);
    host.querySelector('[data-promo-find]').setAttribute('href', fitStarted() ? dialog.getAttribute('data-cart-url') : dialog.getAttribute('data-quiz-url'));
  }

  /* ---------- open / close ---------- */
  function open(forceFirst) {
    if (dialog.open) return;
    var requested = new URLSearchParams(window.location.search).get('popup');
    var saved = recall('fit-popup-variant');
    variant = requested === 'reason' || requested === 'sport' ? requested : saved === 'reason' ? 'reason' : 'sport';
    dialog.setAttribute('data-popup-variant', variant);
    if (forceFirst) show('activity');
    else if (offer.rate === 20) show('success');
    else if (step === 'activity') show('activity');
    priorFocus = document.activeElement;
    /* Shopify mounts its verification window under body. A native modal's top
       layer would cover it and prevent the customer completing verification. */
    if (formsEnabled) {
      backdrop.hidden = false;
      dialog.show();
      verificationTimer = setInterval(function () { dialog.setAttribute('aria-modal', verificationVisible() ? 'false' : 'true'); }, 250);
    }
    else dialog.showModal();
    document.body.style.overflow = 'hidden';
    remember('fit-popup-variant', variant);
    remember('fit-offer-seen', '1');
  }

  function close() {
    dialog.close();
    if (priorFocus && priorFocus.focus) priorFocus.focus();
    remember('fit-offer-seen', '1');
  }

  dialog.addEventListener('close', function () { document.body.style.overflow = ''; clearInterval(verificationTimer); if (backdrop) backdrop.hidden = true; });
  dialog.addEventListener('cancel', function () { remember('fit-offer-seen', '1'); });

  function verificationVisible() {
    var frames = Array.from(document.querySelectorAll('iframe[src*="hcaptcha.com"]'));
    document.querySelectorAll('shopify-forms-embed').forEach(function (embed) {
      if (embed.shadowRoot) frames = frames.concat(Array.from(embed.shadowRoot.querySelectorAll('iframe[src*="hcaptcha.com"]')));
    });
    return frames.some(function (frame) {
      var rect = frame.getBoundingClientRect();
      return rect.width > 100 && rect.height > 100 && getComputedStyle(frame).visibility !== 'hidden';
    });
  }
  function modalControls(root) {
    var controls = [];
    root.querySelectorAll('*').forEach(function (el) {
      if (el.matches('button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])') && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden') controls.push(el);
      if (el.shadowRoot) controls = controls.concat(modalControls(el.shadowRoot));
    });
    return controls;
  }
  document.addEventListener('keydown', function (event) {
    if (!formsEnabled || !dialog.open || verificationVisible()) return;
    if (event.key === 'Escape') { event.preventDefault(); close(); return; }
    if (event.key !== 'Tab') return;
    var controls = modalControls(dialog);
    if (!controls.length) return;
    var active = document.activeElement;
    while (active && active.shadowRoot && active.shadowRoot.activeElement) active = active.shadowRoot.activeElement;
    var index = controls.indexOf(active);
    if (index < 0) index = event.shiftKey ? 0 : -1;
    event.preventDefault();
    controls[(index + (event.shiftKey ? -1 : 1) + controls.length) % controls.length].focus();
  });

  /* ---------- signup (Shopify customer form) ---------- */
  function slug(value) { return value.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }

  function normalizePhone(value) {
    var digits = value.replace(/\D/g, '');
    if (digits.length === 10) return '+1' + digits;
    if (digits.length === 11 && digits[0] === '1') return '+' + digits;
    return '';
  }

  function signup(channel, phone) {
    var fields = new FormData(vehicle);
    fields.set('contact[email]', email.trim().toLowerCase());
    var tags = ['newsletter', 'promo-' + channel, 'popup-' + variant, 'email-consent', 'consent-' + data.consentVersion];
    if (activity) tags.push('activity-' + slug(activity));
    if (channel === 'sms') {
      tags.push('sms-consent');
      fields.set('contact[phone]', phone);
    } else {
      fields.delete('contact[phone]');
    }
    fields.set('contact[tags]', tags.join(','));
    return fetch(vehicle.action, { method: 'POST', body: new URLSearchParams(fields), credentials: 'same-origin' }).then(function (response) {
      var posted = response.redirected || /[?&](customer|contact)_posted=true/.test(response.url);
      if (response.status === 403 || response.url.indexOf('/challenge') !== -1) { var blocked = new Error('challenge'); blocked.fields = fields; blocked.channel = channel; throw blocked; }
      if (!response.ok || !posted) throw new Error('signup');
    });
  }

  /* Shopify sometimes answers background signups with its "Verifying your connection" check.
     Submit the real form instead so the shopper can pass the check, then return here and finish. */
  function submitNatively(fields, channel) {
    fields.forEach(function (value, key) {
      var input = vehicle.querySelector('[name="' + key.replace(/"/g, '\\"') + '"]');
      if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = key; vehicle.appendChild(input); }
      input.value = value;
    });
    var back = new URL(window.location.href);
    back.searchParams.set('promo_signup', channel);
    back.searchParams.set('promo_email', email.trim().toLowerCase());
    back.searchParams.set('promo_activity', activity || '');
    var returnTo = document.createElement('input');
    returnTo.type = 'hidden'; returnTo.name = 'return_to'; returnTo.value = back.pathname + back.search;
    vehicle.appendChild(returnTo);
    vehicle.submit();
  }

  /* Remember the code in the shopper's session so Shopify applies it at checkout; the visible code is the fallback. */
  function applyCode(code) {
    return fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin', redirect: 'manual' }).catch(function () { /* Not needed to continue. */ });
  }

  function submit(form, channel) {
    if (pending) return;
    showError('');
    var consent = form.querySelector('input[type="checkbox"]').checked;
    var phone = '';
    if (channel === 'email') {
      email = form.querySelector('#offer-email').value;
      if (!consent) { showError('Please choose whether to receive emails to unlock this offer.'); return; }
    } else {
      phone = normalizePhone(form.querySelector('#offer-phone').value);
      if (!consent) { showError('Please agree to texts, or keep your 15% email offer.'); return; }
      if (!phone) { showError('Enter a valid US mobile number and agree to texts, or keep your 15% offer.'); return; }
    }
    setPending(true);
    signup(channel, phone).then(function () {
      var rate = channel === 'sms' ? 20 : 15;
      offer = { rate: rate, code: channel === 'sms' ? dialog.getAttribute('data-code-sms') : dialog.getAttribute('data-code-email') };
      saveOffer(offer.rate, offer.code);
      updateTab();
      applyCode(offer.code);
      show(channel === 'email' ? 'sms' : 'success', true);
    }, function (error) {
      if (error && error.message === 'challenge') { submitNatively(error.fields, error.channel); return; }
      setPending(false);
      showError('We couldn’t save your signup. Please try again. Your existing offer is unchanged.');
    });
  }

  /* ---------- events ---------- */
  dialog.addEventListener('click', function (event) {
    var target = event.target;
    if (target.closest('[data-promo-close]')) { close(); return; }
    var choice = target.closest('[data-promo-choices] button');
    if (choice) { activity = choice.textContent; show('email', true); return; }
    var go = target.closest('[data-promo-goto]');
    if (go) { show(go.getAttribute('data-promo-goto'), true); return; }
    if (target.closest('[data-promo-upgrade]')) { show(formsEnabled || email ? 'sms' : 'email', true); return; }
    if (target.closest('[data-promo-find]')) { close(); return; }
    var copy = target.closest('[data-promo-copy]');
    if (copy) {
      var label = copy.querySelector('[data-promo-copy-label]');
      var done = function (text) { label.textContent = text; };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(offer.code).then(function () { done('Copied'); }, function () { done('Copy'); });
    }
  });
  dialog.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-promo-form]');
    if (!form) return;
    event.preventDefault();
    submit(form, form.getAttribute('data-promo-form'));
  });

  tab.addEventListener('click', function () { open(false); });
  window.addEventListener('fit-offer-open', function () { open(false); });
  window.F2F = window.F2F || {};
  window.F2F.openOffer = function () { window.dispatchEvent(new Event('fit-offer-open')); };

  /* ---------- triggers: preview link, desktop exit intent, mobile scroll up ---------- */
  loadOffer();
  updateTab();

  var params = new URLSearchParams(window.location.search);
  var requested = params.get('popup');
  var preview = params.get('offer') === '1' && (requested === 'sport' || requested === 'reason');
  if (preview && !explicitOpened) {
    explicitOpened = true;
    setTimeout(function () { open(true); }, 0);
  }

  var formsReturned = params.get('promo_forms_completed');
  if (formsEnabled && (formsReturned === 'email' || formsReturned === 'sms')) {
    var submitted = null;
    try { submitted = JSON.parse(sessionStorage.getItem('f2f.offer.forms.pending') || 'null'); } catch (e) { /* No expected form completion. */ }
    if (submitted && submitted.channel === formsReturned && typeof submitted.at === 'number' && Date.now() >= submitted.at && Date.now() - submitted.at < 30 * 60 * 1000) {
      activity = submitted.activity || '';
      offer = { rate: formsReturned === 'sms' ? 20 : 15, code: formsReturned === 'sms' ? dialog.getAttribute('data-code-sms') : dialog.getAttribute('data-code-email') };
      saveOffer(offer.rate, offer.code);
      updateTab();
      applyCode(offer.code);
      explicitOpened = true;
      try { sessionStorage.removeItem('f2f.offer.forms.pending'); } catch (e) {}
      setTimeout(function () { open(true); show('success', true); }, 0);
    }
    var cleanReturn = new URL(window.location.href);
    cleanReturn.searchParams.delete('promo_forms_completed');
    window.history.replaceState(null, '', cleanReturn.pathname + cleanReturn.search + cleanReturn.hash);
  }
  var returned = formsEnabled ? null : params.get('promo_signup');
  if (returned === 'email' || returned === 'sms') {
    email = params.get('promo_email') || '';
    activity = params.get('promo_activity') || '';
    offer = { rate: returned === 'sms' ? 20 : 15, code: returned === 'sms' ? dialog.getAttribute('data-code-sms') : dialog.getAttribute('data-code-email') };
    saveOffer(offer.rate, offer.code);
    updateTab();
    applyCode(offer.code);
    explicitOpened = true;
    setTimeout(function () { open(true); show(returned === 'email' ? 'sms' : 'success', true); }, 0);
    window.history.replaceState(null, '', window.location.pathname);
  }

  var triggered = seenBefore();
  var started = Date.now();
  var lastY = window.scrollY;
  function seenBefore() {
    try { return Boolean(sessionStorage.getItem('fit-offer-seen')); } catch (e) { return true; }
  }
  function exitIntent() {
    if (triggered || offer.rate || Date.now() - started < 1200) return;
    triggered = true;
    open(false);
  }
  document.addEventListener('mouseleave', function (event) { if (event.clientY <= 0) exitIntent(); });
  window.addEventListener('scroll', function () {
    var y = window.scrollY;
    if (window.matchMedia('(pointer: coarse)').matches && lastY - y > 70 && lastY > 250) exitIntent();
    lastY = y;
  }, { passive: true });
})();
